import React, { Fragment, useState, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import man from "../assets/images/dashboard/profile.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { sentenceCase, titleCase } from "../utils/case";
import { login } from "../api/auth.api";

const Signin = () => {
  const { t, i18n } = useTranslation();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const loginAuth = async () => {
    if (loading) return;

    if (!identifier || !password) {
      toast.error(sentenceCase(t("invalid username/email or password")));
      return;
    }

    try {
      setLoading(true);

      const user = await login({ identifier, password });

      toast.success(sentenceCase(t("successfully logged in!..")));

      history(`${process.env.PUBLIC_URL}/dashboard`);
    } catch (error) {
      console.log(error);
      toast.error(sentenceCase(error.message));
    } finally {
      setLoading(false);
    }
  };

  // Optional: allow Enter key to trigger login
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      loginAuth();
    }
  };

  return (
    <Fragment>
      <Container fluid className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                {/* Language Switcher */}
                <div className="mb-3 text-end">
                  <select
                    value={i18n.language}
                    onChange={(e) => changeLanguage(e.target.value)}
                    className="form-select w-auto d-inline-block"
                  >
                    <option value="en">EN</option>
                    <option value="cn">中文</option>
                    <option value="bm">BM</option>
                  </select>
                </div>

                <Form className="theme-form">
                  <H4>{titleCase(t("sign in"))}</H4>
                  <P>{sentenceCase(t("enter your email & password to login"))}</P>

                  <FormGroup>
                    <Label className="col-form-label">
                      {titleCase(t("username or email"))}
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </FormGroup>

                  <FormGroup className="position-relative">
                    <Label className="col-form-label">
                      {sentenceCase(t("password"))}
                    </Label>
                    <div className="position-relative">
                      <Input
                        type={togglePassword ? "text" : "password"}
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                      <div
                        className="show-hide"
                        onClick={() => setTogglePassword(!togglePassword)}
                      >
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                  </FormGroup>

                  <div className="position-relative form-group mb-0">
                    <Btn
                      attrBtn={{
                        color: "primary",
                        className: "d-block w-100 mt-2",
                        disabled: loading,
                        onClick: loginAuth,
                      }}
                    >
                      {loading
                        ? t("sign in").toUpperCase() + "..."
                        : t("sign in").toUpperCase()}
                    </Btn>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;